import React from 'react';
import { Box } from '@chakra-ui/react';
import { useColorModeValue } from './chakra-ui/color-mode';
import HeroSection from './hero-section';
import GallerySection from './gallery-section';
import VideoSection from './video-section';

import { COLORS } from '../theme';
import ServicesSection from './services-section';

function Home({ galleryItems, allImages, allVideos }) {
  const heroBgGradient = useColorModeValue(
    COLORS.gradients.hero.light,
    COLORS.gradients.hero.dark
  );
  const bgGradient1 = useColorModeValue(
    COLORS.gradients.neutral.light,
    COLORS.gradients.neutral.dark
  );

  return (
    <div className="Home">
      <Box id="home" bg={heroBgGradient}>
        <HeroSection />
      </Box>
      <Box id="services" bg={bgGradient1}>
        <ServicesSection />
      </Box>
      <Box id="gallery" py={8} bg={bgGradient1}>
        <GallerySection galleryItems={galleryItems} allImages={allImages} />
      </Box>

      <Box id="videos" py={8} bg={bgGradient1}>
        <VideoSection allVideos={allVideos} />
      </Box>
    </div>
  );
}

export default Home;
